<script>
    import appConfig from '@src/app.config'
    import Layout from '@layouts/main'
    import PageHeader from '@components/page-header'
    import DatePicker from 'vue2-datepicker'

    import * as axios from "axios";

    const SITE_NOTICATIONS_API_URL = process.env.VUE_APP_API_URL + 'dashboard/site-notifications';

    /**
     * Advanced table component
     */
    export default {
        page: {
            title: 'Notifications',
            meta: [{ name: 'description', content: appConfig.description }],
        },
        components: { Layout, PageHeader, DatePicker },
        data() {
            return {
                tableData: {
                    goodResult: [],
                    badResult: []
                },
                goodNewsNum: 0,
                badNewsNum:0,

                title: 'Daily Notifications',
                items: [
                    {
                        text: 'Unblockia',
                        href: '/',
                    },
                    {
                        text: 'Notifications',
                        href: '/',
                    },
                ],
                loading: false,
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 25, 50, 100],
                filter: null,
                filterOn: [],
                sortBy: 'name',
                sortDesc: false,
                fields: [
                    { key: 'domain' },
                    { key: 'message' },
                ],
                selectedDate: '',
            }
        },
        computed: {
            isAdmin: () => {
                return JSON.parse(localStorage["auth.currentUser"]).role.name === "admin"
            },
            today: function() {
                return new Date()
            },
            yesterday: function() {
                const d = new Date();
                return d.setDate(d.getDate() - 1)
            },
        },
        async mounted() {
            this.selectedDate = new Date(this.yesterday);
            await this.fetchNotifications();
            // Set the initial number of items
        },
        methods: {
            /**
             * Search the table data with search input
             */
            onFiltered(filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.currentPage = 1
            },
            prettyDate: function (date) {
                // `this` points to the vm instance
                const d = new Date(date);
                const dd = String(d.getDate()).padStart(2, '0');
                const mm = String(d.getMonth() + 1).padStart(2, '0');
                const yyyy = d.getFullYear();
                return yyyy + '-' + mm + '-' + dd;
            },
            async fetchNotifications() {
                this.loading = true;
                const fetchSitesResponse = await axios(SITE_NOTICATIONS_API_URL + `?selectedDate=${this.prettyDate(this.selectedDate)}`);
                this.tableData = fetchSitesResponse.data;
                this.goodNewsNum = this.tableData.goodResult.length;
                this.badNewsNum = this.tableData.badResult.length;
                this.loading = false;
            },
        },
    }
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="d-flex flex-column align-items-end">
            <form class="form-inline flex-form">
              <div class="form-group d-flex flex-wrap col-12">
                <div class="input-group input-group-sm mr-2 ">
                    <div class="input-group input-group-sm">
                        <date-picker
                                v-model="selectedDate"
                                :first-day-of-week="1"
                                class="border-white"
                                :not-after="yesterday"
                                append-to-body
                                lang="en"
                                confirm
                        >
                        
                        </date-picker>
                    </div>
                    <a href="javascript: void(0);" class="btn btn-blue btn-sm ml-2 mr-1 mb-1" @click="fetchNotifications">
                        <i class="mdi mdi-autorenew"></i>
                    </a> 
                    </div>
                </div>
            </form>
        </div>
        

        <b-tabs 
        class="mt-2"
        id="notification-tabs"  
        active-nav-item-class="font-weight-bold" 
        content-class="mt-3"
        >
            <b-tab active>
                <template #title>
                    <i class="mdi mdi-trending-down mr-2 text-danger"/><span>BAD NEWS ({{badNewsNum}})</span>
                </template>
                
                <div v-if="loading" class="row justify-content-center">
                    <b-spinner label="Spinning" class="m-2"></b-spinner>
                
                </div>
                <div v-else class="row">
                    <div v-for="notification in tableData.badResult" :key="notification.tasks" class="col-lg-4 col-sm-6">
                        <div class="card-box notification-box position-relative card-unit card-unit-danger" >
                            <!-- end dropdown -->
                            <!-- Title-->
                            <h4 class="mt-0 mb-0 notification-domain">
                                <a :href="'//' + notification.domain" target="_blank" class="text-dark">{{notification.domain}}</a>
                            </h4>
                            <p class="text-muted ml-0">
                                <small>{{ notification.publisher }}</small>
                            </p>

                            <div class="news-unit mb-3 bg-soft-danger text-danger" >
                                <span> {{(notification.toGrossRevenue - notification.fromGrossRevenue).toFixed(2)}} € </span>

                            </div>
                            <!-- Desc-->
                                <p>
                                    <i class="fe-bar-chart-2 mr-1"></i>
                                    {{notification.fromGrossRevenue.toFixed(2)}}€ --> {{notification.toGrossRevenue.toFixed(2)}}€
                                </p>
                                <p>
                                    <i class="fe-bell mr-1"></i>
                                    <span class="text-dark font-14" v-html="notification.message"></span>
                                </p>
                            
                            <!-- Task info-->
                            <p class="mb-1">

                            </p>
                            <!-- Team-->
                            <div class="avatar-group mb-3 pl-0">
                                <i class="fe-user mr-1"></i>
                                <span class="mt-1 position-relative media-buyer">
                                    {{ notification.mediaBuyer }}
                                </span>

                            </div>
                            <!-- Progress-->
                            <p class="mb-2 see-in-ssps" v-if="isAdmin">
                                <a :href="'/admin/ssps?siteId=' + notification.siteId" target="_blank" class="text-secondary">
                                    See in SSPS page
                                </a>
                            </p>

                            <div>
                                <i v-if="notification.action === 'stop'" class="fe-slash ticket-icon text-danger"></i>
                                <i v-if="notification.action === 'decrease'" class="mdi mdi-arrow-down-bold ticket-icon text-danger"></i>
                            </div>
                        </div>
                        <!-- end card box-->
                    </div>
                    <!-- end col-->
                </div>
                <div v-if="!tableData.badResult.length && !loading" class="d-flex flex-column align-items-center">
                    <img class="bad-news-img mb-3" src="@assets/images/good news.png" alt="">
                    <p class="zero-bad-news text-dark d-inline-flex">✨ No bad news is a good news!! ✨ </p>
                </div>
            </b-tab>
            <b-tab :disabled="goodNewsNum===0">
                <template #title>
                    <i class="mdi mdi-trending-up mr-2 text-success"/><span>GOOD NEWS ({{goodNewsNum}})</span>
                </template>
                <div class="row">
                    <div v-for="notification in tableData.goodResult" :key="notification.tasks" class="col-lg-4 col-sm-6">
                        <div class="card-box notification-box position-relative card-unit card-unit-success" >
                            <!-- end dropdown -->
                            <!-- Title-->
                            <h4 class="mt-0 mb-0 notification-domain">
                                <a :href="'//' + notification.domain" target="_blank" class="text-dark">{{notification.domain}}</a>
                            </h4>
                            <p class="text-muted ml-0">
                                <small>{{ notification.publisher }}</small>
                            </p>

                            <div class="news-unit mb-3 bg-soft-success text-success" >
                                <span> + {{(notification.toGrossRevenue - notification.fromGrossRevenue).toFixed(2)}} € </span>
                                
                            </div>
                            <!-- Desc-->
                                <p>
                                    <i class="fe-bar-chart-2 mr-1"></i>
                                    {{notification.fromGrossRevenue.toFixed(2)}}€ --> {{notification.toGrossRevenue.toFixed(2)}}€
                                </p>
                                <p>
                                    <i class="fe-bell mr-1"></i>
                                    <span class="text-dark font-14" v-html="notification.message"></span>
                                </p>
                            
                            <!-- Task info-->
                            <p class="mb-1">

                            </p>
                            <!-- Team-->
                            <div class="avatar-group mb-3 pl-0">
                                <i class="fe-user mr-1"></i>
                                <span class="mt-1 position-relative media-buyer">
                                    {{ notification.mediaBuyer }}
                                </span>

                            </div>
                            <!-- Progress-->
                            <p class="mb-2 see-in-ssps" v-if="isAdmin">
                                <a :href="'/admin/ssps?siteId=' + notification.siteId" target="_blank" class="text-secondary">
                                    See in SSPS page
                                </a>
                            </p>

                            <div>
                                <i v-if="notification.action === 'start'" class="mdi mdi-flag-checkered ticket-icon text-success"></i>
                                <i v-if="notification.action === 'increase'" class="mdi mdi-arrow-up-bold ticket-icon text-success"></i>
                            </div>
                        </div>
                        <!-- end card box-->
                    </div>
                    <!-- end col-->
                </div>
            </b-tab>
        </b-tabs>


    </Layout>
</template>
<style lang="scss">
    .see-in-ssps {
        position: absolute;
        bottom: 0;
        right: 20px;
        cursor: pointer;

        &:hover {
            color:black;
            text-decoration: underline;

        }
    }

    .avatar-group {
        .media-buyer {
            top: 3px;
        }
    }

    .news-unit{
        padding: 1px 5px;
        display: inline-block;
        // border-radius: 4px;
        span{
            font-size: 0.8rem;
        }
    }

    .card-unit-success{
        border-radius: 0px;
        border-left: rgba(#2AA800, 0.5) 2px solid;
    }

    .card-unit-danger{
        border-radius: 0px;
        border-left: rgba(#f1556c, 0.5) 2px solid;
    }

    .notification-domain{
        display: inline-block;
        width: 95%;
        white-space: nowrap;
        overflow: hidden !important;
        text-overflow: ellipsis;
        font-weight: 500;
    }
    #notification-tabs  {
        .nav-link{
            &.active{
            background-color: transparent;
            border-color: rgba(black, 0.4);
            border-bottom: #f5f6f8 solid 1px;

            }
            &:not(.active):hover{
                border-color: rgba(black, 0.2);
                border-bottom-color: rgba(black, 0.4);
            }
        }

        .nav-tabs {
            border-color: rgba(black, 0.4);
        }

        .zero-bad-news{
            font-size: 1.2rem;
        }

        .bad-news-img{
            width: 300px;

        }

        .ticket-icon{
            position: absolute;
            top: 1.5rem;
            right: 1.5rem;
            font-size: 1.2rem;

            &.mdi{
                top: 1.1rem;
                font-size: 1.5rem;
            }
        }

    }
    
</style>
